import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import Template from '../../../Templates/Home';
import Title from '../../Title';
import Loading from '../../../UI/Loading';
import DownloadCard from '../DownloadCard';

const VideoAndManuals = ({ data, policyData, loading }) => {
  const breadcrumb = [
    { label: 'Dashboard', to: '/home' },
    { label: 'Policy Details', to: '/home/policyDetails' },
    { label: 'Services', to: '/home/services' },
    { label: 'Video And Manuals', active: true },
  ];
  const [tabs, setTabs] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playingVideoId, setPlayingVideoId] = useState(null);

  // const handlePlay = (videosAndManuals) =>
  //   setIsPlaying(true);
  //   const videoElement = document.getElementById(`video-${videosAndManuals.id}`);
  //   if (videoElement) {
  //     videoElement.play();
  //   }
  // };

  const handlePlay = (videoId) => {
    setIsPlaying(true);
    setPlayingVideoId(videoId);
    const videoElement = document.getElementById(`video-${videoId}`);
    if (videoElement) {
      videoElement.play();
    }
  };

  useEffect(() => {
    if (Object.keys(data).length) setTabs(Object.keys(data)[0]);
  }, [data]);

  return (
    <Template pageTitle="Video And Manuals" breadcrumb={breadcrumb}>
      <Container fluid className="max-container mb-5">
        <Title
          policyNumber={policyData?.policyNumber}
          certificateNumber={policyData?.certificateNumber}
          expiryDate={policyData?.expiryDate}
        />
      </Container>
      <section className="metLife-gray">
        <Container fluid className="max-container">
          <Row>
            <Col className="tab-default">
              <Nav tabs className="w-100">
                {data && Object.keys(data).length > 0 && !loading
                  ? Object.keys(data).map((item) => (
                      <NavItem key={item}>
                        <NavLink
                          className={`text-capitalize ${tabs === item ? 'active' : ''}`}
                          onClick={() => setTabs(item)}
                        >
                          {item}
                        </NavLink>
                      </NavItem>
                    ))
                  : null}
              </Nav>

              <TabContent activeTab={tabs}>
                {data && Object.keys(data).length > 0 && !loading ? (
                  Object.keys(data).map(
                    (item) => item === tabs && (
                        <TabPane key={item} tabId={item}>
                          <Row>
                            {data[item]?.length > 0 ? (
                              /* eslint-disable */
                              data[item].map((videosAndManuals) =>
                                item === 'videos' ? (
                                  <Col key={videosAndManuals.id} className="col-12 col-md-6">
                                    <Card className="mb-4 shadow">
                                      <CardBody className="p-0">
                                        {!isPlaying || playingVideoId !== videosAndManuals.id ? (
                                          <div
                                            className="video-thumbnail"
                                            onClick={() => handlePlay(videosAndManuals.id)}
                                            style={{
                                              cursor: 'pointer',
                                              position: 'relative',
                                              width: '100%',
                                              background: `url(${videosAndManuals?.thumbnail}) center/cover no-repeat`,
                                              paddingTop: '56.25%', // Maintain aspect ratio (16:9)
                                            }}
                                          >
                                            <div className="player">
                                              <span />
                                            </div>
                                          </div>
                                        ) : (
                                          <video id={`video-${videosAndManuals.id}`} width="100%" controls>
                                            <source src={videosAndManuals.file_path} />
                                            <track kind="captions" />
                                          </video>
                                        )}
                                        {/* <Row className="m-0 pb-2">
                                        <Col>
                                          <Label className="mb-0">{videosAndManuals.name}</Label>
                                        </Col>
                                      </Row> */}
                                      </CardBody>
                                    </Card>
                                  </Col>
                                ) : (
                                  <Col className="col-12 col-md-6 gg-default service-list mb-2">
                                    <DownloadCard item={videosAndManuals} openFile key={videosAndManuals?.id} />
                                  </Col>
                                ),
                              )
                            ) : (
                              <Col>
                                <Card>
                                  <div className="no-results">
                                    <div style={{ textAlign: 'center' }}>
                                      <svg
                                        className="noresults-searchicon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="31"
                                        height="31"
                                        viewBox="0 0 31 31"
                                      >
                                        <path
                                          id="Icon_Search"
                                          data-name="Icon/Search"
                                          d="M18.752,21h0L21,18.795l-6.033-5.916a7.956,7.956,0,0,0,.67-8.452A8.331,8.331,0,0,0,.466,5.433,8.036,8.036,0,0,0,3.1,14.458a8.4,8.4,0,0,0,9.551.555L18.751,21ZM8.27,3.118a5.058,5.058,0,0,1,5.1,5,5.1,5.1,0,0,1-10.2,0A5.058,5.058,0,0,1,8.27,3.118Z"
                                          transform="translate(5 5)"
                                          fill="#ddd"
                                        />
                                      </svg>
                                      <CardBody className="pt-0">
                                        <CardTitle tag="h5">No Results Found</CardTitle>
                                      </CardBody>
                                    </div>
                                  </div>
                                </Card>
                              </Col>
                            )}
                          </Row>
                        </TabPane>
                      ),
                  )
                ) : loading ? (
                  <Col>
                    <Loading />
                  </Col>
                ) : (
                  <Col>
                    <div className="no-results">
                      <CardBody className="pt-0">
                        <CardTitle tag="h5">No Data Available</CardTitle>
                      </CardBody>
                    </div>
                  </Col>
                )}
              </TabContent>
            </Col>
          </Row>
        </Container>
      </section>
    </Template>
  );
};

VideoAndManuals.propTypes = {
  data: PropTypes.shape({
    videos: PropTypes.array,
    manuals: PropTypes.array,
  }),
  policyData: PropTypes.shape({
    policyNumber: PropTypes.number,
    certificateNumber: PropTypes.string,
    expiryDate: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
};

VideoAndManuals.defaultProps = {
  data: [],
  loading: false,
};

export default withRouter(VideoAndManuals);
